var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.$style.wrap, _vm.fullScreen && _vm.$style.fullScreen]},[_vm._m(0),_c('main',[_c('div',{class:_vm.$style.content},[_c('div',{attrs:{"id":"captcha"}})])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',[_c('span',[_vm._v("滑动验证")])])
}]

export { render, staticRenderFns }